import { DASH } from 'shared/constants';
import { FormatterFunction } from 'shared/types';

export const formatUnit: FormatterFunction = (value): string => {
  if (value === undefined || value === null) return DASH;

  const formatter = new Intl.NumberFormat('en-US', {
    maximumFractionDigits: 0,
  });

  return `${formatter.format(value)}`;
};
